import React, { useState } from "react";
import CustomField from "../../components/common/customField";
import { onlyNumberdesimal } from "../../helpers/formats";
import { isPastDate } from "../../components/common/utlity/utility";

const PaymentDetails = ({
  handlePaidAmountChange,
  handleCommitmentChange,
  isPurchase,
  handleSaleDateChange,
  isAdvance,
  totalAmount, // Add this prop
}) => {
  const [paidAmount, setPaidAmount] = useState("");
  const [committedDay, setCommittedDay] = useState("");
  const [saleDate, setSaleDate] = useState("");

  const handlePaidAmountInput = (event) => {
    const { value } = event.target;
    setPaidAmount(value);
    handlePaidAmountChange(value);
  };

  const handleCommitmentInput = (event) => {
    const { id, value } = event.target;
    if (id === "saleDate") {
      setSaleDate(value);
      handleSaleDateChange(value);
    } else {
      setCommittedDay(value);
      handleCommitmentChange(value);
    }
  };

  return (
    <div className='flex flex-col'>
      <div className='mb-4 grid grid-cols-2 mt-4 gap-4'>
        <div className='col-span-1 mr-1'>
          <CustomField
            type='text'
            id='paidAmount'
            label='Paid Amount'
            name='paidAmount'
            value={paidAmount}
            handleChange={handlePaidAmountInput}
            onKeyPress={onlyNumberdesimal}
          />
          {totalAmount !== undefined && paidAmount > totalAmount && (
            <p className='text-red-500 text-sm mt-1'>
              Paid amount cannot be greater than the due amount.
            </p>
          )}
        </div>

        <div className='col-span-1 mr-2' style={{ marginLeft: "-2%" }}>
          {isPurchase === true && isAdvance === true ? (
            <CustomField
              type='date'
              id='saleDate'
              label={isPurchase ? "Purchase Date" : "Sale Date"}
              name='saleDate'
              value={saleDate}
              onChange={handleCommitmentInput}
              InputLabelProps={{ shrink: true }}
              size='small'
              className='w-full'
              placeholder='DD-MM-YYYY'
            />
          ) : (
            <CustomField
              type='date'
              id='committedDay'
              label='Commit date to Pay'
              name='committedDay'
              value={committedDay}
              onChange={handleCommitmentInput}
              InputLabelProps={{
                shrink: true,
              }}
              size='small'
              error={paidAmount > 0 && committedDay === ""}
              helperText={
                paidAmount > 0 && committedDay === ""
                  ? "Committed Date is required"
                  : isPastDate(committedDay)
                    ? "Committed Date Cannot be Past"
                    : ""
              }
              className='w-full'
              placeholder='DD-MM-YYYY'
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentDetails;
